/**
 * Custom Hook - useModels
 * Manages model-related state and operations
 */

import { useState, useEffect, useCallback } from 'react';
import { deploymentInstanceService } from '../services/DeploymentInstanceService';

export function useInstances() {
  const [instances, setInstances] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadInstances = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await deploymentInstanceService.getDeploymentInstances();
      setInstances(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load models');
    } finally {
      setLoading(false);
    }
  }, []);

  // Load models on mount
  useEffect(() => {
    loadInstances();
  }, [loadInstances]);

  return {
    instances,
    loading,
    error,
    refreshInstances: loadInstances,
  };
}
